import controllerLoadedObservableFactory from '@newswebsiteapp/shared/observables/controllerLoadedObservableFactory'
import renderDonateApp from '@newswebsiteapp/shared/react/donations'
import getSearchParam from '@newswebsiteapp/shared/lib/getSearchParam'

controllerLoadedObservableFactory('newsletter').subscribe(() => {
  const selectPaypalDonationRecipient =
    getSearchParam('paypal', window.location.href) !== null
  const selectMayorDonationRecipient =
    getSearchParam('colorado', window.location.href) !== null

  console.log('selectPaypalDonationRecipient', selectPaypalDonationRecipient)
  console.log('selectMayorDonationRecipient', selectMayorDonationRecipient)

  let selectedNonDefaultDonationRecipient_name = null
  // http://localhost:3000/special-donation?paypal=true
  if (selectPaypalDonationRecipient) { selectedNonDefaultDonationRecipient_name = 'vs. PayPal' }
  // http://localhost:3000/special-donation?colorado=true
  if (selectMayorDonationRecipient) { selectedNonDefaultDonationRecipient_name = 'vs. Mayor' }

  renderDonateApp({
    url: '/api/special-donation/donate',
    selectedNonDefaultDonationRecipient_name,
  })
})
